/**
 * Redis client initialization using Upstash Redis SDK
 * Singleton instance for Redis operations
 */

import { Redis } from '@upstash/redis';

let redisClient: Redis | null = null;

/**
 * Get the Redis client instance (singleton)
 * Uses Redis.fromEnv() which automatically reads from:
 * - KV_REST_API_URL
 * - KV_REST_API_TOKEN
 * @returns Redis client instance
 */
export function getRedisClient(): Redis {
  if (redisClient) {
    return redisClient;
  }

  // Check if Upstash REST API is configured
  if (!process.env.KV_REST_API_URL || !process.env.KV_REST_API_TOKEN) {
    throw new Error('KV_REST_API_URL and KV_REST_API_TOKEN environment variables are required');
  }

  // Initialize from environment variables
  redisClient = Redis.fromEnv();

  return redisClient;
}

/**
 * Check if Redis is available
 * @returns True if Redis is configured, false otherwise
 */
export function isRedisAvailable(): boolean {
  return !!(process.env.KV_REST_API_URL && process.env.KV_REST_API_TOKEN);
}

/**
 * Close Redis connection (for cleanup/testing)
 * Note: Upstash REST API doesn't require explicit connection management
 */
export async function closeRedisConnection(): Promise<void> {
  redisClient = null;
}
